import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ResultCard from "@/components/ResultCard";
import ResultCardSkeleton from "@/components/ResultCardSkeleton";
import StructuredData from "@/components/StructuredData";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useLotteryResults } from "@/hooks/useLotteryResults";

const NicaAyer = () => {
  const { data: results, isLoading } = useLotteryResults(1);
  const nicaraguaResults = results?.nicaraguaResults || [];

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toLocaleDateString('es-ES', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <>
      <StructuredData
        title="Resultados de Ayer - Diaria Loto Nicaragua"
        description="Resultados de ayer de la Diaria Loto de Nicaragua"
        results={nicaraguaResults}
        country="nicaragua"
      />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1 container mx-auto px-4 py-8">
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-nicaragua">
              🇳🇮 ¿Qué salió ayer en la Nica?
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2">
              Resultados de ayer de la Loto Diaria de Nicaragua, sorteo por sorteo
            </p>
            <p className="text-sm text-muted-foreground capitalize">{yesterdayStr}</p>
          </header>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Button asChild variant="outline">
              <Link to="/tiempos-nica-hoy">Hoy</Link>
            </Button>
            <Button asChild variant="default">
              <Link to="/que-salio-ayer-en-la-nica">Ayer</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/nica-antier">Antier</Link>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {isLoading ? (
              <>
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
                <ResultCardSkeleton country="nicaragua" />
              </>
            ) : nicaraguaResults.length > 0 ? (
              nicaraguaResults.map((result, index) => (
                <ResultCard
                  key={index}
                  country="nicaragua"
                  {...result}
                />
              ))
            ) : (
              <p className="text-center text-muted-foreground col-span-full">No hay resultados disponibles para ayer.</p>
            )}
          </div>
          {!isLoading && nicaraguaResults.some((r) => r.isPlayed) && (
            <section className="mt-12 max-w-3xl mx-auto space-y-4">
              <h2 className="text-2xl font-bold">¿Qué salió ayer en la Nica en cada sorteo?</h2>
              {nicaraguaResults.filter((r) => r.isPlayed).map((r) => (
                <div key={r.time}>
                  <h3 className="font-semibold">¿Qué salió ayer en la Nica a las {r.time}?</h3>
                  <p className="text-muted-foreground">
                    Ayer ({yesterdayStr}) a las {r.time} salió el número <strong>{r.number}</strong>.
                  </p>
                </div>
              ))}
            </section>
          )}
        </main>

        <Footer />
      </div>
    </>
  );
};

export default NicaAyer;
